
export default {
  components: {},
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {
    steps: {
      handler(newVal) {
        this.$nextTick(() => {
          if (this.$refs.stepItem) {
            for (let i = 0; i < this.$refs.stepItem.length; i++) {
              this.$refs.stepItem[i].style.width = (1 / this.$refs.stepItem.length) * 100 + "%"
            }
          }
        })
      },
      immediate: true
    }
  },
  created() {},
  mounted() {},

  methods: {}
}
